<!-- Footer -->
<footer class="bg-gray-800 text-gray-300">
    <div class="container mx-auto px-6 py-10">
        <div class="grid grid-cols-1 md:grid-cols-4 gap-8">
            <!-- Company Vision -->
            <div>
                <h3 class="font-semibold text-white mb-4">Our Vision</h3>
                <p class="text-sm text-gray-400">We recognized on the earth to strive the High Quality Product and genuine service for every business to reach at top.</p>
            </div>
            <!-- Address -->
            <div>
                <h3 class="font-semibold text-white mb-4">Our Office</h3>
                <p class="text-sm text-gray-400">Apprevio Technology office 103,<br>Arvi Road Gandi Nagar Wardha,<br> Maharashtra 442001. <br> Landmark:- Opposite First Cry.</p>
            </div>
            <!-- BranchAddress -->
            <div>
                <h3 class="font-semibold text-white mb-4">Branch Office</h3>
                <p class="text-sm text-gray-400">Saraf Court, M-1, <br>Opposite Yashwant Stadium, Dhantoli, <br> Nagpur, Maharashtra 440012</p>
            </div>
            <!-- Contact Info -->
            <div>
                <h3 class="font-semibold text-white mb-4">Contact Us</h3>
                <ul class="text-sm space-y-2 text-gray-400">
                    <li class="flex items-center">
                        <svg class="w-5 h-5 mr-3" fill="currentColor" viewBox="0 0 20 20"><path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"></path><path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"></path></svg>
                        <span>info@apprevio.in</span>
                    </li>
                    <li class="flex items-center">
                        <svg class="w-5 h-5 mr-3" fill="currentColor" viewBox="0 0 20 20">
                <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"></path></svg>
                        <span>+91-9970 347 900</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="mt-8 border-t border-gray-700 pt-6 text-center text-gray-500">
            <p>&copy; 2024 Apprevio Technology. All Rights Reserved </p>
        </div>
    </div>
</footer>